<template>
  <div class="bgWhite">
    <bread :data="bread" />
    <searchForm :searchHandle="searchHandle" />
    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      size="mini"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="name" label="菜单名" sortable width="200"></el-table-column>
      <el-table-column prop="sort" label="排序" sortable></el-table-column>
      <el-table-column prop="createDate" label="创建时间" sortable></el-table-column>
      <el-table-column prop="updateDate" label="修改时间" sortable></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="upload(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="del(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <OfficeAdd ref="OfficeAdd" :title="title" />
  </div>
</template>
<!-- 菜单管理 -->
<script>
import bread from "@/components/Module/Bread";
import searchForm from "@/components/Module/From";
import cesTable from "@/components/Module/Table";
import OfficeAdd from "./Module/Office/OfficeAdd";
import { officeTreeApi, officeDelApi } from "@/api/api";

export default {
  name: "",
  data() {
    return {
      bread: [
        {
          link: "",
          name: "首页"
        },
        {
          link: "",
          name: "系统管理"
        },
        {
          link: "",
          name: "部门管理"
        }
      ],
      title: "",
      searchHandle: [
        {
          label: "新增",
          type: "primary",
          handle: row => this.add()
        }
      ],
      tableData: []
    };
  },
  methods: {
    add() {
      this.title='新增部门';
      this.$refs.OfficeAdd.init();
    },
    upload(i,v){
       this.title='修改部门';
       this.$refs.OfficeAdd.init(v);
    },
    del(index, row) {
      elMsgBox("您确定要删除这条记录吗？", "del").then(res => {
        officeDelApi(row.id).then(res => {
          elMsg("删除成功");
          this.getData();
        })
      });
    },
    getData(){
      officeTreeApi().then(res => {
        console.log(res);
        this.tableData = res[0].children;
      });
    }
  },
  created() {
    this.getData();
  },
  components: {
    bread,
    searchForm,
    cesTable,
    OfficeAdd
  }
};
</script>

<style lang="less" scoped>
ul {
  display: inline-block;
  width: 100%;
  height: 48px;
  padding: 12px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #ebeef5;
}
li {
  float: left;
  width: 20%;
  padding: 0 10px;
  box-sizing: border-box;
  color: #909399;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 14px;
  padding-right: 8px;
}
</style>